import { takeLatest, all } from "redux-saga/effects";
import * as sagas from "./saga-actions";
export default function* rootSaga() {
  // let token = yield localStorage.auth && JSON.parse(localStorage.auth).token ? JSON.parse(localStorage.auth).token : null
  // if(!token){
  //   yield take('LOGIN_SUCCESS')
  //   token = yield JSON.parse(localStorage.auth).token
  // }
  // if(token){
  yield all([
    takeLatest("FETCH_MEMBER", sagas.fetchMember),
    takeLatest("FETCH_CITIES", sagas.fetchCities),
    takeLatest("FETCH_USERS", sagas.fetchUsers),
    takeLatest("FETCH_PROMOTIONS", sagas.fetchPromotions),
    takeLatest("FETCH_DETAIL_PROMOTION", sagas.fetchDetailPromotion),
    takeLatest("FETCH_GROUP_PRODUCT", sagas.fetchGroupProduct),
    takeLatest("FETCH_NOTIFICATIONS", sagas.fetchNotifications),
    takeLatest("FETCH_USER_GROUP", sagas.fetchUserGroup),
    takeLatest("FETCH_USER_GROUP_DETAIL", sagas.fetchUserGroupDetail),
    takeLatest("FETCH_PERMISSION_BY_GROUP", sagas.fetchPermissionByGroup),
    takeLatest("FETCH_PERMISSION_USER", sagas.fetchPermissionUser),
    takeLatest("FETCH_PERMISSION", sagas.fetchPermission),
  ]);
  // }
}
